import { RootState } from '@/App/store';

export const selectScreenRefDataMap = (state: RootState) => state.refdata.screenRefDataMap;
